import styled from 'styled-components';

export const TemplateListWrapper = styled.div`
  /* The page itself must not grow past the viewport, otherwise .content (display:flex; flex:1 in
     main.styled.js) just gets taller and nothing scrolls - same arrangement as FormWrapper. */
  max-height: 100vh;
  overflow: hidden;

  .list-header,
  .list-row {
    display: grid;
    grid-template-columns: 2fr 3fr 1fr 1fr;
    align-items: center;
    column-gap: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  .list-header {
    color: ${({ theme }) => theme.colors.LighterText};
    /* Opaque, not backgroundColor_05: rows scroll underneath a sticky header. */
    background: ${({ theme }) => theme.colors.ZenLightGray};
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .list-row {
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => theme.colors.hoverColor};
    }
  }

  .status-pill {
    border-radius: 12px;
    padding: 2px 10px;
    width: fit-content;

    &.active {
      background: ${({ theme }) => theme.colors.ZenPositiveSecondary};
      color: ${({ theme }) => theme.colors.ZenPositiveText};
    }

    &.archived {
      background: ${({ theme }) => theme.colors.ZenGraySecondary_05};
      color: ${({ theme }) => theme.colors.Gray2};
    }
  }

  .muted {
    color: ${({ theme }) => theme.colors.LighterText};
  }
`;

export const TemplateVersionsWrapper = styled.div`
  /* The organisations list reuses .list-header/.list-row but only has a name and a menu. */
  .template-organizations {
    .list-header,
    .list-row {
      grid-template-columns: 1fr 60px;
    }
  }

  /* The page itself must not grow past the viewport, otherwise .content (display:flex; flex:1 in
     main.styled.js) just gets taller and nothing scrolls - same arrangement as FormWrapper. */
  max-height: 100vh;
  overflow: hidden;

  .list-header,
  .list-row {
    display: grid;
    grid-template-columns: 80px 1fr 1fr 1fr 260px;
    align-items: center;
    column-gap: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  .list-header {
    color: ${({ theme }) => theme.colors.LighterText};
    /* Opaque, not backgroundColor_05: rows scroll underneath a sticky header. */
    background: ${({ theme }) => theme.colors.ZenLightGray};
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .list-row:hover {
    background: ${({ theme }) => theme.colors.hoverColor};
  }

  .status-pill {
    border-radius: 12px;
    padding: 2px 10px;
    width: fit-content;

    &.published {
      background: ${({ theme }) => theme.colors.ZenPositiveSecondary};
      color: ${({ theme }) => theme.colors.ZenPositiveText};
    }

    &.archived {
      background: ${({ theme }) => theme.colors.ZenGraySecondary_05};
      color: ${({ theme }) => theme.colors.Gray2};
    }

    &.draft {
      background: ${({ theme }) => theme.colors.ZenOrangeSecondary};
      color: ${({ theme }) => theme.colors.ZenOrangeText};
    }
  }

  .muted {
    color: ${({ theme }) => theme.colors.LighterText};
  }
`;
